// LoginSignUpButton.jsx
import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import { color } from '../style/variables.js';
import { ButtonId } from '../resource/mixpanel.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { NULL_FUNCTION } from '../resource/defaults.js';

export const LoginSignUpButton = ({ login = NULL_FUNCTION }) => {
  const { t } = useTranslation();

  return (
    <SignupButton
      data-element_id={ButtonId.LoginRegister.ButtonLogin}
      onClick={() => {
        return login({ entry: 'register' });
      }}
    >
      <SignupButtonText>
        {t('login_and_register', {
          ns: TranslationNamespace.SETTINGS,
        })}
      </SignupButtonText>
    </SignupButton>
  );
};

LoginSignUpButton.propTypes = {
  login: PropTypes.func,
};

// const StyledLoginSignUpButton = styled.div``;

const AuthButton = styled.button`
  ${ResetButtonStyle};
  margin-left: 8px;
  flex: none;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.016px;
  border-radius: 4px;
  transition: opacity 0.4s;
  opacity: 1;
  @media (hover: hover) {
    :hover {
      opacity: 0.8;
    }
  }
`;

const SignupButton = styled(AuthButton)`
  color: ${color.neutral[0]};
  background-color: ${color.tealBlue};
`;

const SignupButtonText = styled.div``;

export default LoginSignUpButton;
